var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.332 18.334a6.667 6.667 0 1 1 13.333 0zm7.5-4.93v3.263h3.882a5.01 5.01 0 0 0-3.882-3.264m-1.667 3.263v-3.264a5.01 5.01 0 0 0-3.882 3.264zM7 10.834c-2.763 0-5-2.238-5-5s2.237-5 5-5 5 2.237 5 5-2.238 5-5 5m0-1.667a3.33 3.33 0 0 0 3.333-3.333 3.33 3.33 0 0 0-3.333-3.333 3.33 3.33 0 0 0-3.334 3.333A3.33 3.33 0 0 0 7 9.167"
  })));
};
export default SvgUser;